$.fn.hamburgerButton = function () {
    var $this = $(this);
    $this.target = $this.data('target');

    $($this.data('target')).on('show.bs.collapse', function () {
        $this.addClass('is-active');
    });
    $($this.data('target')).on('hide.bs.collapse', function () {
        $this.removeClass('is-active');
    });
};


/**
 * Init Hamburger
 */
$('.hamburger').each(function () {
    $(this).hamburgerButton();
});
